<mat-drawer-container
  class="h-screen !bg-white font-display text-[#1E1E1E]"
  autosize
>
  <mat-drawer
    [opened]="true"
    #drawer
    class="shadow-nav !bg-white !text-[#1F9AA2]"
    mode="side"
    [ngStyle]="isOpened ? { width: '300px' } : { width: '72px' }"
  >
    @if (isOpened) {
    <div class="w-full flex flex-col py-6 space-y-14">
      <div class="flex items-center justify-center">
        <div
          class="h-20 w-20 rounded-full bg-white flex items-center justify-center border border-gray-300"
        >
          <img src="logo mavens.png" alt="" class="h-14 2-14" />
        </div>
      </div>
      <div class="flex flex-col space-y-6 w-full">
        <a routerLink="/dashboard/home" class="px-10">
          <div
            routerLinkActive="bg-[#1F9AA2] text-white p-2 rounded-lg"
            class="w-full flex items-center space-x-4"
          >
            <div
              class="w-8 flex items-center justify-center"
              routerLinkActive="bg-[#1F9AA2]"
            >
              <i class="fa-solid fa-house"></i>
            </div>
            <span class="font-semibold">Home</span>
          </div>
        </a>
        @if (authService.isSysAdmin(currentUser) ||
        authService.isHrd(currentUser) || authService.isFinance(currentUser)) {
        <mat-accordion>
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div
                  class="flex items-center space-x-4 w-full font-display !text-[#1F9AA2]"
                >
                  <div class="w-8 flex items-center justify-center">
                    <i class="fa-solid fa-people-group"></i>
                  </div>
                  <span class="font-semibold">Company</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div
              class="pl-[5.5rem] pt-4 flex flex-col space-y-4 font-display !text-[#1F9AA2]"
            >
              @if (authService.isSysAdmin(currentUser) ||
              authService.isHrd(currentUser)) {
              <a
                routerLink="/dashboard/team"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Team</a
              >
              <a
                routerLink="/dashboard/position"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Position</a
              >
              } @if (authService.isSysAdmin(currentUser)) {
              <a
                routerLink="/dashboard/employee"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Employee</a
              >
              } @if (authService.isSysAdmin(currentUser) ||
              authService.isFinance(currentUser)) {
              <a
                routerLink="/dashboard/expense-category"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Expense Category</a
              >
              <a
                routerLink="/dashboard/tag"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Tag</a
              >
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        } @if (authService.isSysAdmin(currentUser) ||
        authService.isFinance(currentUser) ||
        authService.isApprover(currentUser) ||
        authService.isManagement(currentUser) ||
        authService.isAdminIntegration(currentUser) ||
        authService.isHrd(currentUser) || authService.isPic(currentUser)) {
        <mat-accordion>
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div
                  class="flex items-center space-x-4 w-full font-display !text-[#1F9AA2]"
                >
                  <div class="w-8 flex items-center justify-center">
                    <i class="fa-solid fa-clipboard-list"></i>
                  </div>
                  <span class="font-semibold flex items-center gap-2">
                    Reimbursement
                    @if (pendingReimbursement > 0) {
                    <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                      {{ pendingReimbursement > 99 ? '99+' : pendingReimbursement }}
                    </span>
                    }
                  </span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div
              class="pl-[5.5rem] pt-4 flex flex-col space-y-4 font-display !text-[#1F9AA2]"
            >
              @if (authService.isSysAdmin(currentUser) ||
              authService.isFinance(currentUser) ||
              authService.isApprover(currentUser) ||
              authService.isManagement(currentUser) ||
              authService.isAdminIntegration(currentUser) ||
              authService.isHrd(currentUser) || authService.isPic(currentUser))
              {
              <a
                routerLink="/dashboard/reimbursement-claimer"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Claimer</a
              >
              } @if (authService.isApprover(currentUser) ||
              authService.isSysAdmin(currentUser)) {
              <a
                routerLink="/dashboard/reimbursement-approval"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
              >
                <span class="flex items-center gap-2">
                  Approval
                  @if (pendingReimbursement > 0) {
                  <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                    {{ pendingReimbursement > 99 ? '99+' : pendingReimbursement }}
                  </span>
                  }
                </span>
              </a>
              } @if (authService.isFinance(currentUser) ||
              authService.isSysAdmin(currentUser)) {
              <a
                routerLink="/dashboard/reimbursement-finance"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Finance</a
              >
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        } @if (authService.isSysAdmin(currentUser) ||
        authService.isFinance(currentUser) ||
        authService.isApprover(currentUser) ||
        authService.isManagement(currentUser) ||
        authService.isAdminIntegration(currentUser) ||
        authService.isHrd(currentUser) || authService.isPic(currentUser)) {
        <mat-accordion>
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div
                  class="flex items-center space-x-4 w-full font-display !text-[#1F9AA2]"
                >
                  <div class="w-8 flex items-center justify-center">
                    <i class="fa-solid fa-credit-card"></i>
                  </div>
                  <span class="font-semibold flex items-center gap-2">
                    Cash Advance
                    @if (pendingCashAdvance > 0) {
                    <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                      {{ pendingCashAdvance > 99 ? '99+' : pendingCashAdvance }}
                    </span>
                    }
                  </span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div
              class="pl-[5.5rem] pt-4 flex flex-col space-y-4 font-display !text-[#1F9AA2]"
            >
              @if (authService.isSysAdmin(currentUser) ||
              authService.isFinance(currentUser) ||
              authService.isApprover(currentUser) ||
              authService.isManagement(currentUser) ||
              authService.isAdminIntegration(currentUser) ||
              authService.isHrd(currentUser) || authService.isPic(currentUser))
              {
              <a
                routerLink="/dashboard/cash-advance-claimer"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Claimer</a
              >
              } @if (authService.isApprover(currentUser) ||
              authService.isSysAdmin(currentUser)) {
              <a
                routerLink="/dashboard/cash-advance-approval"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
              >
                <span class="flex items-center gap-2">
                  Approver
                  @if (pendingCashAdvance > 0) {
                  <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                    {{ pendingCashAdvance > 99 ? '99+' : pendingCashAdvance }}
                  </span>
                  }
                </span>
              </a>
              <a
                routerLink="/dashboard/cash-advance-settlement"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
              >
                <span class="flex items-center gap-2">
                  Settlement
                  @if (pendingSettlement > 0) {
                  <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                    {{ pendingSettlement > 99 ? '99+' : pendingSettlement }}
                  </span>
                  }
                </span>
              </a>
              } @if (authService.isFinance(currentUser) ||
              authService.isSysAdmin(currentUser)) {
              <a
                routerLink="/dashboard/cash-advance-finance"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Finance</a
              >
              <a
                routerLink="/dashboard/finance-overview"
                routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
                class="font-semibold inline-block"
                >Finance Overview</a
              >
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        } @if (canAccessReportMenu) {
        <a routerLink="/dashboard/report" class="px-10">
          <div
            routerLinkActive="bg-[#1F9AA2] text-white p-2 rounded-lg"
            class="w-full flex items-center space-x-4"
          >
            <div
              class="w-8 flex items-center justify-center"
              routerLinkActive="bg-[#1F9AA2]"
            >
              <i class="fa-solid fa-house"></i>
            </div>
            <span class="font-semibold">Report</span>
          </div>
        </a>
        }
        @if (authService.isSysAdmin(currentUser)) {
        <a routerLink="/dashboard/final-transaction-recap" class="px-10">
          <div
            routerLinkActive="bg-[#1F9AA2] text-white p-2 rounded-lg"
            class="w-full flex items-center space-x-4"
          >
            <div
              class="w-8 flex items-center justify-center"
              routerLinkActive="bg-[#1F9AA2]"
            >
              <i class="fa-solid fa-folder-tree"></i>
            </div>
            <span class="font-semibold">Final Recap</span>
          </div>
        </a>
        }
      </div>
    </div>
    } @else {
    <div class="w-full flex flex-col py-9 space-y-14">
      <div class="flex items-center justify-center">
        <div
          class="h-12 w-12 rounded-full bg-white flex items-center justify-center border border-gray-300"
        >
          <img src="logo mavens.png" alt="" class="h-14 2-14" />
        </div>
      </div>
      <div class="flex flex-col items-center justify-center space-y-12">
        <a routerLink="/dashboard/home" matTooltip="Home">
          <div
            routerLinkActive="bg-[#1F9AA2] text-white p-2 rounded-lg"
            class="w-full flex items-center space-x-4"
          >
            <div
              class="w-8 flex items-center justify-center"
              routerLinkActive="bg-[#1F9AA2]"
            >
              <i class="fa-solid fa-house text-xl"></i>
            </div>
          </div>
        </a>
        @if (authService.isSysAdmin(currentUser) ||
        authService.isHrd(currentUser) || authService.isFinance(currentUser)) {
        <button
          matTooltip="Company"
          [matMenuTriggerFor]="company"
          class="flex items-center justify-center space-x-4 w-full font-display !text-[#1F9AA2]"
        >
          <div class="w-8 flex items-center justify-center text-xl">
            <i class="fa-solid fa-people-group"></i>
          </div>
        </button>
        }
        <mat-menu #company="matMenu">
          <div
            class="flex flex-col space-y-8 font-display !text-[#1F9AA2] px-4 py-2"
          >
            @if (authService.isSysAdmin(currentUser) ||
            authService.isHrd(currentUser)) {
            <a
              routerLink="/dashboard/team"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Team</a
            >
            <a
              routerLink="/dashboard/position"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Position</a
            >
            } @if (authService.isSysAdmin(currentUser)) {
            <a
              routerLink="/dashboard/employee"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Employee</a
            >
            } @if (authService.isSysAdmin(currentUser) ||
            authService.isFinance(currentUser)) {
            <a
              routerLink="/dashboard/expense-category"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Expense Category</a
            >
            <a
              routerLink="/dashboard/tag"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Tag</a
            >
            }
            <!-- <a
              routerLink="/dashboard/number-format"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Number Format</a
            >
            <a
              routerLink="/dashboard/source"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Source</a
            > -->
          </div>
        </mat-menu>
        @if (authService.isSysAdmin(currentUser) ||
        authService.isFinance(currentUser) ||
        authService.isApprover(currentUser) ||
        authService.isManagement(currentUser) ||
        authService.isAdminIntegration(currentUser) ||
        authService.isHrd(currentUser) || authService.isPic(currentUser)) {
        <button
          [matMenuTriggerFor]="reimbursement"
          matTooltip="Reimbursement"
          class="relative flex items-center justify-center space-x-4 w-full font-display !text-[#1F9AA2]"
        >
          <div class="w-8 flex items-center justify-center text-xl">
            <i class="fa-solid fa-clipboard-list"></i>
          </div>
          @if (pendingReimbursement > 0) {
          <span class="absolute -top-1 right-2 inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[9px] font-bold min-w-[16px] h-[16px] px-1">
            {{ pendingReimbursement > 99 ? '99+' : pendingReimbursement }}
          </span>
          }
        </button>
        }
        <mat-menu #reimbursement="matMenu">
          <div
            class="flex flex-col space-y-8 font-display !text-[#1F9AA2] px-4 py-2"
          >
            @if (authService.isSysAdmin(currentUser) ||
            authService.isFinance(currentUser) ||
            authService.isApprover(currentUser) ||
            authService.isManagement(currentUser) ||
            authService.isAdminIntegration(currentUser) ||
            authService.isHrd(currentUser) || authService.isPic(currentUser)) {
            <a
              routerLink="/dashboard/reimbursement-claimer"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Claimer</a
            >
            } @if (authService.isApprover(currentUser) ||
            authService.isSysAdmin(currentUser)) {
            <a
              routerLink="/dashboard/reimbursement-approval"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
            >
              <span class="flex items-center gap-2">
                Approval
                @if (pendingReimbursement > 0) {
                <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                  {{ pendingReimbursement > 99 ? '99+' : pendingReimbursement }}
                </span>
                }
              </span>
            </a>
            } @if (authService.isFinance(currentUser) ||
            authService.isSysAdmin(currentUser)) {
            <a
              routerLink="/dashboard/reimbursement-finance"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Finance</a
            >
            }
          </div>
        </mat-menu>
        @if (authService.isSysAdmin(currentUser) ||
        authService.isFinance(currentUser) ||
        authService.isApprover(currentUser) ||
        authService.isManagement(currentUser) ||
        authService.isAdminIntegration(currentUser) ||
        authService.isHrd(currentUser) || authService.isPic(currentUser)) {
        <button
          [matMenuTriggerFor]="cash"
          matTooltip="Cash Advance"
          class="relative flex items-center justify-center space-x-4 w-full font-display !text-[#1F9AA2]"
        >
          <div class="w-8 flex items-center justify-center text-xl">
            <i class="fa-solid fa-credit-card"></i>
          </div>
          @if (pendingCashAdvance > 0) {
          <span class="absolute -top-1 right-2 inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[9px] font-bold min-w-[16px] h-[16px] px-1">
            {{ pendingCashAdvance > 99 ? '99+' : pendingCashAdvance }}
          </span>
          }
        </button>
        }
        <mat-menu #cash="matMenu">
          <div
            class="flex flex-col space-y-8 font-display !text-[#1F9AA2] px-4 py-2"
          >
            @if (authService.isSysAdmin(currentUser) ||
            authService.isFinance(currentUser) ||
            authService.isApprover(currentUser) ||
            authService.isManagement(currentUser) ||
            authService.isAdminIntegration(currentUser) ||
            authService.isHrd(currentUser) || authService.isPic(currentUser)) {
            <a
              routerLink="/dashboard/cash-advance-claimer"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Claimer</a
            >
            } @if (authService.isApprover(currentUser) ||
            authService.isSysAdmin(currentUser)) {
            <a
              routerLink="/dashboard/cash-advance-approval"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
            >
              <span class="flex items-center gap-2">
                Approver
                @if (pendingCashAdvance > 0) {
                <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                  {{ pendingCashAdvance > 99 ? '99+' : pendingCashAdvance }}
                </span>
                }
              </span>
            </a>
            <a
              routerLink="/dashboard/cash-advance-settlement"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
            >
              <span class="flex items-center gap-2">
                Settlement
                @if (pendingSettlement > 0) {
                <span class="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1">
                  {{ pendingSettlement > 99 ? '99+' : pendingSettlement }}
                </span>
                }
              </span>
            </a>
            } @if (authService.isFinance(currentUser) ||
            authService.isSysAdmin(currentUser)) {
            <a
              routerLink="/dashboard/cash-advance-finance"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Finance</a
            >
            <a
              routerLink="/dashboard/finance-overview"
              routerLinkActive="bg-[#1F9AA2] text-white px-2 py-1 rounded-lg w-max"
              class="font-semibold inline-block"
              >Finance Overview</a
            >
            }
          </div>
        </mat-menu>
        @if (canAccessReportMenu) {
        <a
          routerLink="/dashboard/report"
          matTooltip="Report"
          class="flex items-center justify-center space-x-4 w-full font-display !text-[#1F9AA2]"
        >
          <div class="w-8 flex items-center justify-center text-xl">
            <i class="fa-solid fa-rectangle-list"></i>
          </div>
        </a>
        }
        @if (authService.isSysAdmin(currentUser)) {
        <a
          routerLink="/dashboard/final-transaction-recap"
          matTooltip="Final Recap"
          class="flex items-center justify-center space-x-4 w-full font-display !text-[#1F9AA2]"
        >
          <div class="w-8 flex items-center justify-center text-xl">
            <i class="fa-solid fa-folder-tree"></i>
          </div>
        </a>
        }
      </div>
    </div>
    }
  </mat-drawer>
  <div class="dashboard-shell p-4 sm:p-6 lg:p-8 flex flex-col gap-3">
    <header class="dashboard-navbar">
      <div class="navbar-left">
        <button
          type="button"
          (click)="isOpened = !isOpened"
          class="navbar-toggle"
          aria-label="Toggle sidebar"
        >
          <i
            [ngClass]="isOpened ? 'fa-chevron-left' : 'fa-chevron-right'"
            class="fa-solid"
          ></i>
        </button>
        <div class="navbar-brand min-w-0">
          <p class="navbar-brand__title" title="PT Mavens Mitra Perkasa">
            PT Mavens Mitra Perkasa
          </p>
          <p class="navbar-brand__date">
            {{ today | date : "d MMMM yyyy" : "+0700" }}
          </p>
        </div>
      </div>

      <div class="navbar-right">
        <div class="navbar-actions">
          <button
            type="button"
            [matMenuTriggerFor]="notif"
            #notifTrigger="matMenuTrigger"
            class="navbar-icon-btn"
            aria-label="Notifications"
          >
            <i class="fa-solid fa-bell"></i>
            <span *ngIf="!isRead" class="navbar-icon-btn__dot"></span>
          </button>
        <mat-menu
          #notif="matMenu"
          class="!w-[90vw] sm:!w-[420px] lg:!w-[500px]"
          panelClass="notif-menu"
        >
          <div class="flex flex-col font-display">
            <div class="notif-menu__header">
              <div class="flex min-w-0 flex-col">
                <span class="text-base font-semibold text-slate-900 sm:text-lg"
                  >Your notifications</span
                >
                <span class="text-xs text-slate-500">
                  {{ notificationData.length || 0 }} recent updates
                </span>
              </div>
              <div class="flex shrink-0 items-center gap-2">
                <button
                  *ngIf="notificationData.length && !isRead"
                  class="inline-flex h-9 items-center gap-2 rounded-full border border-[#BFE6E9] bg-[#EEF9FA] px-3 text-xs font-semibold text-[#1F9AA2] transition hover:bg-[#E3F5F7] sm:text-sm"
                  (click)="readAllNotification()"
                >
                  <i class="fa-solid fa-check-double"></i>
                  <span>Mark all as read</span>
                </button>
                <button
                  type="button"
                  class="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition hover:bg-slate-50"
                  (click)="notifTrigger.closeMenu()"
                  aria-label="Close notifications"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
            <mat-divider class="!border-[#E5E7EB]"></mat-divider>
            <div
              *ngIf="!notificationData.length"
              class="flex flex-col items-center justify-center px-6 py-12 text-center"
            >
              <div
                class="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400"
              >
                <i class="fa-solid fa-bell-slash"></i>
              </div>
              <span class="text-sm font-medium text-slate-700"
                >No notifications</span
              >
              <span class="mt-1 text-xs text-slate-500"
                >All recent activity will appear here.</span
              >
            </div>
            <ng-container *ngIf="notificationData.length">
              <div class="notif-menu__list">
                <ng-container *ngFor="let item of notificationData">
                <div
                  class="notif-item"
                  [ngClass]="{ 'notif-item--unread': !item.isRead }"
                  (click)="readNotification(item)"
                >
                  <div class="flex min-w-0 items-start gap-3">
                    <div
                      class="notif-item__icon"
                      [ngClass]="getNotificationIconClass(item.type)"
                    >
                      <i class="fa-solid" [ngClass]="getNotificationIcon(item.type)"></i>
                    </div>
                    <div class="flex min-w-0 flex-1 flex-col space-y-1">
                      <span
                        class="text-sm leading-5 text-slate-700"
                        [ngClass]="{ 'font-semibold': !item.isRead }"
                        >{{ item.description }}</span
                      >
                      <span class="text-xs font-medium text-slate-500">{{
                        item.created_at | date : "d MMM y, HH:mm" : "+0700"
                      }} WIB</span>
                    </div>
                  </div>
                  <div
                    *ngIf="!item.isRead"
                    class="mt-1 min-h-2.5 min-w-2.5 rounded-full bg-[#1F9AA2]"
                  ></div>
                </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </mat-menu>

        <button
          type="button"
          [matMenuTriggerFor]="setting"
          class="navbar-icon-btn"
          aria-label="Settings"
        >
          <i class="fa-solid fa-gear"></i>
        </button>
        <mat-menu #setting="matMenu">
          <div class="flex flex-col font-display p-4 min-w-[10rem]">
            <span class="font-semibold text-base text-slate-900">Settings</span>
            <div class="my-2 border-t border-slate-200"></div>
            <a
              routerLink="/dashboard/profile"
              class="text-sm text-slate-600 py-1.5 hover:text-slate-900"
              >Profile</a
            >
            <a
              routerLink="/dashboard/faq"
              class="text-sm text-slate-600 py-1.5 hover:text-slate-900"
              >FAQ</a
            >
            <button
              type="button"
              class="text-sm text-slate-600 py-1.5 text-left hover:text-slate-900"
              (click)="logout()"
            >
              Log out
            </button>
          </div>
        </mat-menu>
      </div>

      <a routerLink="/dashboard/profile" class="navbar-profile">
        <img
          [src]="imageUrl || 'profile.png'"
          alt="Foto profil"
          class="navbar-profile__avatar"
        />
        <div class="navbar-profile__info hidden sm:block min-w-0">
          <p class="navbar-profile__name truncate">
            {{ currentUser.firstName }} {{ currentUser.lastName }}
          </p>
          <p class="navbar-profile__meta truncate" *ngIf="getUserMeta()">
            {{ getUserMeta() }}
          </p>
        </div>
      </a>
      </div>
    </header>
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
